import { useTranslation } from "@bounce/i18n"
import { formatNickname } from "@bounce/store"
import type { StoreWithNickname } from "@bounce/store"
import type { Nullable } from "@bounce/util"

type UseStoreNicknameArgs = {
  store: Nullable<StoreWithNickname>
}

export const useStoreNickname = ({ store }: UseStoreNicknameArgs) => {
  const { t, i18n } = useTranslation()

  const nickname = formatNickname({ nickname: store?.nickname ?? "", language: i18n.language })

  if (store?.type === "Locker") {
    return nickname
  }

  return t("hook.useStoreNickname.nicknameV1", {
    defaultValue: "{{nickname}} Luggage Storage",
    nickname,
  })
}
